module.exports = __webpack_public_path__ + "static/media/sentinel.32921d48.png";